// src/theme/factorySeasonal.ts
// Use the central themes registry so we don't depend on a named export from productionTheme.ts
import { themes } from "@/theme/themes";
import { resolveProductionTheme } from "@/theme/productionTheme";  

export type ThemeRecord = Record<string, any>;
const clone = <T,>(x: T) => JSON.parse(JSON.stringify(x)) as T;

// Base all seasonal factories off whatever "production" is in themes.ts
const productionTheme = themes.production ?? {};
const base = clone(productionTheme);

export const seasonalFactories: Record<"summer"|"spring"|"fall"|"winter", ThemeRecord> = {
  summer: {
    ...base,
    // gentle warm accent
    buttonBg: "#f59e0b",
    galleryCtaBg: "#f59e0b",
    galleryCtaText: "#1f2937",
    galleryCtaHoverBg: "#d97706",
    galleryCtaHoverText: "#111111",

    aboutBtnBg: "#f59e0b",
    aboutBtnText: "#1f2937",
    aboutBtnHoverBg: "#d97706",
    aboutBtnHoverText: "#111111",

    recognitionBtnText: base["fontBody"],

    awardsBtnBg: "#f59e0b",
    awardsBtnText: "#1f2937",
    awardsBtnHoverBg: "#d97706",
    awardsBtnHoverText: "#111111",

    clientBtnBg: "#f59e0b",
    clientBtnText: "#1f2937",
    clientBtnHoverBg: "#d97706",
    clientBtnHoverText: "#111111",

    galleryTabBg: "#fde68a",
    galleryTabText: "#111827",
    galleryTabHoverBg: "#fcd34d",
    galleryTabHoverText: "#111827",
  },

  spring: {
    ...base,
    buttonBg: "#ec4899",
    galleryCtaBg: "#ec4899",
    galleryCtaText: "#ffffff",
    galleryCtaHoverBg: "#db2777",
    galleryCtaHoverText: "#ffffff",

    aboutBtnBg: "#ec4899",
    aboutBtnText: "#ffffff",
    aboutBtnHoverBg: "#db2777",
    aboutBtnHoverText: "#ffffff",

    recognitionBtnText: base["fontBody"],

    awardsBtnBg: "#ec4899",
    awardsBtnText: "#ffffff",
    awardsBtnHoverBg: "#db2777",
    awardsBtnHoverText: "#ffffff",

    clientBtnBg: "#ec4899",
    clientBtnText: "#ffffff",
    clientBtnHoverBg: "#db2777",
    clientBtnHoverText: "#ffffff",

    galleryTabBg: "#fce7f3",
    galleryTabText: "#9d174d",
    galleryTabHoverBg: "#fbcfe8",
    galleryTabHoverText: "#831843",
  },

  fall: {
    ...base,
    buttonBg: "#b45309",
    galleryCtaBg: "#b45309",
    galleryCtaText: "#ffffff",
    galleryCtaHoverBg: "#92400e",
    galleryCtaHoverText: "#ffffff",

    aboutBtnBg: "#b45309",
    aboutBtnText: "#ffffff",
    aboutBtnHoverBg: "#92400e",
    aboutBtnHoverText: "#ffffff",

    recognitionBtnText: base["fontBody"],

    awardsBtnBg: "#b45309",
    awardsBtnText: "#ffffff",
    awardsBtnHoverBg: "#92400e",
    awardsBtnHoverText: "#ffffff",

    clientBtnBg: "#b45309",
    clientBtnText: "#ffffff",
    clientBtnHoverBg: "#92400e",
    clientBtnHoverText: "#ffffff",

    galleryTabBg: "#fcd9bd",
    galleryTabText: "#7c2d12",
    galleryTabHoverBg: "#fdba74",
    galleryTabHoverText: "#7c2d12",
  },

  winter: {
    ...base,
    buttonBg: "#0284c7",
    galleryCtaBg: "#0284c7",
    galleryCtaText: "#e5f3fb",
    galleryCtaHoverBg: "#0369a1",
    galleryCtaHoverText: "#e5f3fb",

    aboutBtnBg: "#0284c7",
    aboutBtnText: "#e5f3fb",
    aboutBtnHoverBg: "#0369a1",
    aboutBtnHoverText: "#e5f3fb",

    recognitionBtnText: base["fontBody"],

    awardsBtnBg: "#0284c7",
    awardsBtnText: "#e5f3fb",
    awardsBtnHoverBg: "#0369a1",
    awardsBtnHoverText: "#e5f3fb",

    clientBtnBg: "#0284c7",
    clientBtnText: "#e5f3fb",
    clientBtnHoverBg: "#0369a1",
    clientBtnHoverText: "#e5f3fb",

    galleryTabBg: "#e0f2fe",
    galleryTabText: "#0c4a6e",
    galleryTabHoverBg: "#bae6fd",
    galleryTabHoverText: "#0c4a6e",
  },
};

export const getFactoryForTheme = (name: string): ThemeRecord | null => {
  switch (name) {
    case "summer": return seasonalFactories.summer;
    case "spring": return seasonalFactories.spring;
    case "fall":   return seasonalFactories.fall;
    case "winter": return seasonalFactories.winter;
    default:       return null;
  }
};
